import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import moment from "moment";
import { toast } from "react-toastify";
import $ from "jquery";
import { minDate } from "../../Constants/Constants";

const UpdateTKCSOrderDispatch = ({
  govt_order_details_id,
  formRef,
  getData,
  rowId,
  setRowId,
  productName,
}) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [company, setCompany] = useState([]);
  const [selectCompanyId, setSelectCompanyId] = useState("");
  const [productId, setProductId] = useState("");
  const [yardId, setYardID] = useState("");
  const [closingStockInYard, setClosingStockInYard] = useState("");
  const [singleGovtOrderNumber, setSingleGovtOrderNumber] = useState([]);
  const [initialYardIds, setInitialYardIds] = useState([]);
  const [initialCompanyIds, setInitialCompanyIds] = useState([]);
  const [initialProductNameIds, setInitialProductNameIds] = useState([]);
  const [tripExistId, setTripExistId] = useState("");
  const [existFlag, setExistFlag] = useState(false);
  const [orderNumbers, setOrderNumbers] = useState([
    {
      company_id: "",
      yard_id: "",
      product_name_id: "",
      dispatch_qty: "",
      p_damage_stock: 0,
      p_shortage_stock: 0,
      p_over_stock: 0,
    },
  ]);
  const [product, setProduct] = useState(Array(orderNumbers?.length).fill([]));
  const [yard, setYard] = useState(Array(orderNumbers?.length).fill([]));
  const [rowAddData, setRowAddData] = useState({
    order_number: "",
    date: "",
    status: "",
  });
  const [vehicle, setVehicle] = useState([]);
  const [vehicleNumber, setVehicleNumber] = useState("");
  const closeModal = () => {
    $(".custon-close-button-color").trigger("click");
  };

  const getCompany = async () => {
    const BASE_URL = SERVER_URL + `/api/company/all-company-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setCompany(result.data);
    } else {
      setCompany([]);
    }
  };

  useEffect(() => {
    getCompany();
  }, []);

  useEffect(() => {
    if (rowId) {
      handleSingleGovtOrderNumber();
    }
  }, [rowId]);

  useEffect(() => {
    if (singleGovtOrderNumber) {
      const list = singleGovtOrderNumber?.dispatch_details?.map((item) => ({
        yard_id: item.yard_id,
        yard_name: item.yard_name,
        company_id: item.company_id,
        company_name: item.company_name,
        product_name_id: item.product_name_id,
        product_name: item.size,
        dispatch_qty: item.dispatch_qty,
        p_damage_stock: item.p_damage_stock,
        p_shortage_stock: item.p_shortage_stock,
        p_over_stock: item.p_over_stock,
        yard_detail_id: item.yard_detail_id,
      }));
      setOrderNumbers(list);
      setInitialYardIds(
        singleGovtOrderNumber?.dispatch_details?.map((item) => item.yard_id)
      );
      setInitialProductNameIds(
        singleGovtOrderNumber?.dispatch_details?.map(
          (item) => item.product_name_id
        )
      );
      setInitialCompanyIds(
        singleGovtOrderNumber?.dispatch_details?.map((item) => item.company_id)
      );
    }
  }, [singleGovtOrderNumber]);

  useEffect(() => {
    if (initialCompanyIds && initialCompanyIds?.length > 0) {
      const productLists = [];
      const yardLists = [];
      initialCompanyIds.forEach((companyId, index) => {
        const selectedCompany = company.find(
          (item) => item.id === parseInt(companyId)
        );
        if (selectedCompany) {
          const yards = selectedCompany.companyYard.map((yard) => ({
            id: yard.id,
            yard_name: yard.yard_name,
          }));
          yardLists[index] = yards;

          const products = selectedCompany.productName.map((product) => ({
            id: product.id,
            size: product.size,
          }));
          productLists[index] = products;
        }
      });
      setProduct(productLists);
      setYard(yardLists);
    }
  }, [initialCompanyIds]);

  const addOrderNumberRow = () => {
    setOrderNumbers([
      ...orderNumbers,
      {
        company_id: "",
        yard_id: "",
        product_name_id: "",
        dispatch_qty: "",
        p_damage_stock: 0,
        p_shortage_stock: 0,
        p_over_stock: 0,
      },
    ]);
    setSelectCompanyId(""); // Reset selectCompanyId to empty string
    setProductId(""); // Reset productId to empty string
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSingleGovtOrderNumber(() => {
      return {
        ...singleGovtOrderNumber,
        [name]: value,
      };
    });
  };

  const handleSingleGovtOrderNumber = async () => {
    let BASE_URL =
      SERVER_URL +
      `/api/tkcs-dispatch/single-tkcs-order-dispatch/${user_id}?dispach_order_id=${rowId}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setSingleGovtOrderNumber(result.data);
    } else {
      setSingleGovtOrderNumber([]);
    }
  };

  const removeOrderNumberRow = (index) => {
    const updatedOrderNumbers = [...orderNumbers];
    updatedOrderNumbers.splice(index, 1);
    setOrderNumbers(updatedOrderNumbers);
  };

  const handleCompanyChange = (e, index) => {
    setSelectCompanyId(e.target.value);
    const updatedOrderNumbers = [...orderNumbers];
    updatedOrderNumbers[index].company_id = e.target.value;
    setOrderNumbers(updatedOrderNumbers);
    const selectedCompanyId = e.target.value;
    const selectedCompany = company.find(
      (item) => item.id === parseInt(selectedCompanyId)
    );
    if (selectedCompany) {
      const yards = selectedCompany.companyYard.map((yard) => ({
        id: yard.id,
        yard_name: yard.yard_name,
      }));
      const updatedYards = [...yard];
      updatedYards[index] = yards;
      setYard(updatedYards);
      const prodcts = selectedCompany.productName.map((product) => ({
        id: product.id,
        size: product.size,
      }));
      const updatedProducts = [...product];
      updatedProducts[index] = prodcts;
      setProduct(updatedProducts);
    }
  };

  const getSingleYardDetailClosing = async () => {
    const BASE_URL = `${SERVER_URL}/api/yard-details/single-yard-details/${user_id}?company_id=${selectCompanyId}&product_name_id=${productId}&yard_id=${yardId}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setClosingStockInYard(result.data);
    } else {
      setClosingStockInYard("");
    }
  };

  useEffect(() => {
    if (yardId) {
      getSingleYardDetailClosing();
    }
  }, [yardId, productId, selectCompanyId]);

  const getTripExist = async () => {
    const BASE_URL = `${SERVER_URL}/api/trips/trip-exist/${user_id}?vehicle_details_id=${vehicleNumber}&dispatch_date=${singleGovtOrderNumber.dispatch_date}&status=${false}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      toast.dismiss();
      setTripExistId(result.data.id);
      setExistFlag(true);
    } else {
      setTripExistId("");
      setExistFlag(false);
      toast.error(result.message);
    }
  };

  useEffect(() => {
    if (vehicleNumber && singleGovtOrderNumber.dispatch_date) {
      getTripExist();
    }
  }, [vehicleNumber, singleGovtOrderNumber.dispatch_date]);

  const handleProductChange = (e, index) => {
    setProductId(e.target.value);
    const updatedOrderNumbers = [...orderNumbers];
    updatedOrderNumbers[index].product_name_id = e.target.value;
    setOrderNumbers(updatedOrderNumbers);
  };

  const handleYardChange = (e, index) => {
    setYardID(e.target.value);
    const updatedOrderNumbers = [...orderNumbers];
    updatedOrderNumbers[index].yard_id = e.target.value;
    setOrderNumbers(updatedOrderNumbers);
  };

  const handleQtyChange = (e, index, field) => {
    const updatedOrderNumbers = [...orderNumbers];
    updatedOrderNumbers[index][field] = e.target.value;
    setOrderNumbers(updatedOrderNumbers);
  };

  const handleSave = (e) => {
    e.preventDefault();
    console.log(orderNumbers);
  };

  const handleAddDataSubmit = async (e) => {
    e.preventDefault();
    const {
      id,
      invoice_qty,
      dispatch_date,
      gp_number,
      invoice_date,
      invoice_number,
      remarks,
    } = singleGovtOrderNumber;
    if (!existFlag) {
      toast.error(
        "Please check the existence of trip over the dispatch date and vehicle number"
      );
      return;
    }
    let BASE_URL =
      SERVER_URL + `/api/tkcs-dispatch/tkcs-order-dispatch/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "PUT",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id,
        order_number_id: govt_order_details_id,
        vehicle_details_id: vehicleNumber,
        dispatch_details: orderNumbers,
        invoice_qty,
        dispatch_date,
        gp_number,
        invoice_date,
        invoice_number,
        remarks,
        trip_id: tripExistId
      }),
    });
    const response = await res.json();

    if (res.ok) {
      getData();
      closeModal();
      resetFields();
      setTimeout(() => {
        toast.success(response.message);
      }, 1000);
    } else {
      toast.error(response.message);
    }
  };

  function resetFields() {
    setSingleGovtOrderNumber({
      gp_number: "",
      invoice_qty: "",
      dispatch_date: "",
      invoice_date: "",
      invoice_number: "",
      vehicle_number: "",
      remarks: "",
    });
    setProduct([]);
    setYardID("");
    setRowId("");
    setSelectCompanyId("");
    setClosingStockInYard("");
    setProductId("");
    setTripExistId("")
    setOrderNumbers([
      {
        company_id: "",
        yard_id: "",
        product_name_id: "",
        dispatch_qty: "",
        p_damage_stock: 0,
        p_shortage_stock: 0,
        p_over_stock: 0,
      },
    ]);
    setVehicleNumber("");
  }

  const getVehicle = async () => {
    const BASE_URL =
      SERVER_URL + `/api/vehicle-details/all-vehicle-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setVehicle(result.data);
    } else {
      setVehicle([]);
    }
  };

  useEffect(() => {
    getVehicle();
  }, []);

  const handleVehicleChange = (e) => {
    setVehicleNumber(e.target.value);
  };

  useEffect(() => {
    if (singleGovtOrderNumber) {
      setVehicleNumber(singleGovtOrderNumber?.vehicleDetails?.id);
    }
  }, [singleGovtOrderNumber]);
  return (
    <>
      <div
        className="modal custom-modal fade"
        id="update"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="imageZoomModalTitle">
                Update Dispatch Order Details
              </h5>
              <button
                type="button"
                className="custon-close-button-color close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={resetFields}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div style={{ textAlign: "center" }} className="mb-4">
                <h6>
                  <i className="fa fa-info-circle"></i> Stock in Yard for
                  selected details :{" "}
                  <span style={{ fontSize: "18px" }}>
                    {closingStockInYard
                      ? closingStockInYard?.p_closing_stock
                      : 0}
                  </span>
                </h6>
              </div>
              <div className="col-12 grid-margin">
                <div className="card">
                  <div className="card-body">
                    <form
                      className="form-sample"
                      onSubmit={handleSave}
                      //   ref={formRef}
                    >
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="order">DI Number</label>
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control"
                                name="di_number"
                                id="order"
                                placeholder="DI Number"
                                readOnly
                                onChange={handleChange}
                                value={
                                  singleGovtOrderNumber?.privateDiNumber
                                    ?.di_number
                                }
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="date">Date</label>
                            <div className="input-group">
                              <input
                                type="date"
                                className="form-control"
                                name="date"
                                id="date"
                                placeholder="Date"
                                max={new Date().toISOString().split("T")[0]}
                                onChange={handleChange}
                                value={
                                  singleGovtOrderNumber?.privateDiNumber
                                    ?.di_date
                                }
                                readOnly
                                min={minDate}
                              />
                            </div>
                          </div>
                        </div>
                        {/* <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="status">Status</label>
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control"
                                name="status"
                                id="status"
                                placeholder="Status"
                                onChange={handleChange}
                                value={singleGovtOrderNumber?.status}
                              />
                            </div>
                          </div>
                        </div> */}
                      </div>
                      <div className="row">
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="GP">GP Number</label>
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control"
                                name="gp_number"
                                id="GP"
                                placeholder="GP Number"
                                onChange={handleChange}
                                value={singleGovtOrderNumber?.gp_number}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="dispatch_date">Dispatch Date</label>
                            <div className="input-group">
                              <input
                                type="date"
                                className="form-control"
                                name="dispatch_date"
                                id="dispatch_date"
                                placeholder="Dispatch Date"
                                onChange={handleChange}
                                value={singleGovtOrderNumber?.dispatch_date}
                                min={minDate}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="invoice">Invoice Date</label>
                            <div className="input-group">
                              <input
                                type="date"
                                className="form-control"
                                name="invoice_date"
                                id="invoice"
                                placeholder="Invoice Date"
                                onChange={handleChange}
                                value={singleGovtOrderNumber?.invoice_date}
                                min={minDate}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="qty">Invoice Qty</label>
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control"
                                name="invoice_qty"
                                id="qty"
                                placeholder="Invoice Qty"
                                onChange={handleChange}
                                value={singleGovtOrderNumber?.invoice_qty}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="invoice_number">
                              Invoice Number
                            </label>
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control"
                                name="invoice_number"
                                id="invoice_number"
                                placeholder="Invoice Number"
                                onChange={handleChange}
                                value={singleGovtOrderNumber?.invoice_number}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="Vehicle">Vehicle Number</label>
                            <select
                              className="form-control form-control-lg"
                              value={vehicleNumber}
                              onChange={handleVehicleChange}
                              id="Vehicle"
                            >
                              <option value="">Select Vehicle</option>
                              {vehicle &&
                                vehicle?.length > 0 &&
                                vehicle?.map((item, id) => (
                                  <option
                                    key={id}
                                    value={item.id}
                                  >{`${item.vehicle_number}`}</option>
                                ))}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="remarks">Remarks</label>
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control"
                                name="remarks"
                                id="remarks"
                                placeholder="Remarks"
                                onChange={handleChange}
                                value={singleGovtOrderNumber?.remarks}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      {singleGovtOrderNumber?.dispatch_details?.length > 0 &&
                        orderNumbers?.map((order, index) => {
                          const isInitialYardId =
                            order.yard_id &&
                            Array.isArray(initialYardIds) &&
                            initialYardIds.includes(order.yard_id);
                          const isInitialCompanyId =
                            order.company_id &&
                            Array.isArray(initialCompanyIds) &&
                            initialCompanyIds.includes(order.company_id);
                          const isInitialProductNameId =
                            order.product_name_id &&
                            Array.isArray(initialProductNameIds) &&
                            initialProductNameIds.includes(
                              order.product_name_id
                            );
                          return (
                            <div key={index} className="row">
                              <div className="col-md-2">
                                <div className="form-group">
                                  <label htmlFor="Company">Company Name</label>
                                  <select
                                    className="form-control form-control-lg"
                                    value={order.company_id}
                                    disabled={isInitialCompanyId}
                                    onChange={(e) =>
                                      handleCompanyChange(e, index)
                                    }
                                    id="Company"
                                  >
                                    <option value="">Select Company</option>
                                    {company &&
                                      company?.length > 0 &&
                                      company.map((item, id) => (
                                        <option
                                          key={id}
                                          value={item.id}
                                        >{`${item.company_name}, ${item.location}`}</option>
                                      ))}
                                  </select>
                                </div>
                              </div>
                              <div className="col-md-2">
                                <div className="form-group">
                                  <label htmlFor="product">Product Name</label>
                                  <select
                                    className="form-control form-control-lg"
                                    value={order.product_name_id}
                                    onChange={(e) =>
                                      handleProductChange(e, index)
                                    }
                                    disabled={
                                      !selectCompanyId || isInitialProductNameId
                                    }
                                  >
                                    <option value="">Select Product</option>
                                    {product &&
                                      product[index]
                                        ?.filter(
                                          (item) => item.size == productName
                                        )
                                        ?.map((item, id) => (
                                          <option
                                            key={id}
                                            value={item.id}
                                          >{`${item.size}`}</option>
                                        ))}
                                  </select>
                                </div>
                              </div>
                              <div className="col-md-2">
                                <div className="form-group">
                                  <label htmlFor="yard">Yard Name</label>
                                  <select
                                    className="form-control form-control-lg"
                                    value={order.yard_id}
                                    onChange={(e) => handleYardChange(e, index)}
                                    disabled={
                                      !selectCompanyId || isInitialYardId
                                    }
                                  >
                                    <option value="">Select yard</option>
                                    {yard &&
                                      yard[index]?.map((item, id) => (
                                        <option
                                          key={id}
                                          value={item.id}
                                        >{`${item.yard_name}`}</option>
                                      ))}
                                  </select>
                                </div>
                              </div>
                              <div className="col-md-2">
                                <div className="form-group">
                                  <label htmlFor="qty">Dispatch Quantity</label>
                                  <div className="input-group">
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={order.dispatch_qty}
                                      onChange={(e) =>
                                        handleQtyChange(
                                          e,
                                          index,
                                          "dispatch_qty"
                                        )
                                      }
                                      name="dispatch_qty"
                                      placeholder="Dispatch Quantity"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-2">
                                <div className="form-group">
                                  <label htmlFor="p_damage_stock">
                                    Damage Quantity
                                  </label>
                                  <div className="input-group">
                                    <input
                                      type="number"
                                      className="form-control"
                                      value={order.p_damage_stock}
                                      onChange={(e) =>
                                        handleQtyChange(
                                          e,
                                          index,
                                          "p_damage_stock"
                                        )
                                      }
                                      name="p_damage_stock"
                                      placeholder="Damage Quantity"
                                      min="0"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-2">
                                <div className="form-group">
                                  <label htmlFor="p_shortage_stock">
                                    Shortage Quantity
                                  </label>
                                  <div className="input-group">
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={order.p_shortage_stock}
                                      onChange={(e) =>
                                        handleQtyChange(
                                          e,
                                          index,
                                          "p_shortage_stock"
                                        )
                                      }
                                      name="p_shortage_stock"
                                      placeholder="Shortage Quantity"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-2">
                                <div className="form-group">
                                  <label htmlFor="p_over_stock">
                                    Over Stock Quantity
                                  </label>
                                  <div className="input-group">
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={order.p_over_stock}
                                      onChange={(e) =>
                                        handleQtyChange(
                                          e,
                                          index,
                                          "p_over_stock"
                                        )
                                      }
                                      name="p_over_stock"
                                      placeholder="Over Stock/Goods Return Quantity"
                                    />
                                    <span className="input-group-append ml-2">
                                      <div className="col-md-2">
                                        <button
                                          type="button"
                                          title="Remove"
                                          disabled={
                                            isInitialCompanyId ||
                                            isInitialProductNameId ||
                                            isInitialYardId
                                          }
                                          className="btn btn-outline-danger btn-rounded btn-icon"
                                          onClick={() =>
                                            removeOrderNumberRow(index)
                                          }
                                        >
                                          <span className="mdi mdi-close-thick"></span>
                                        </button>
                                      </div>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      <span className="input-group-append ml-2">
                        <button
                          className="btn btn-primary mt-3"
                          type="button"
                          onClick={addOrderNumberRow}
                        >
                          Add More
                        </button>
                      </span>
                      <button
                        className="btn btn-primary mr-2 mt-3"
                        type="submit"
                        onClick={handleAddDataSubmit}
                      >
                        Save
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdateTKCSOrderDispatch;
